import React, { useCallback } from 'react';
import { useGATrackEvent } from '@app/analytics';
import { trackEvent as segmentTrackEvent, EVENTS } from '@app/segment';
import { usePageType } from '@app/page';

import useAboutMenu from './hooks/useAboutMenu';
import ListMenu from '../shared/components/ListMenu';
import AboutDropdown from './components/AboutDropdown';

type AboutMenuProps = {
  title?: string;
  handleClose?: Function;
  format?: 'list' | 'dropdown';
};

const AboutMenu = ({ title, handleClose, format }: AboutMenuProps) => {
  const { items } = useAboutMenu();

  const gaTrackEvent = useGATrackEvent();
  const screenName = usePageType();

  const handleOnClick = useCallback(
    (item) => {
      gaTrackEvent(
        'Top Navigation About Clicked',
        'All',
        item.eventLabel ?? undefined,
      );
      segmentTrackEvent(EVENTS.NAVIGATION_ITEM_CLICKED, {
        label: item.eventLabel ?? undefined,
        screenName,
      });

      if (handleClose) {
        handleClose();
      }
    },
    [gaTrackEvent, handleClose, screenName],
  );

  if (format === 'dropdown') {
    return <AboutDropdown items={items} itemHandleOnClick={handleOnClick} />;
  }

  return (
    <ListMenu title={title} items={items} itemHandleOnClick={handleOnClick} />
  );
};

export default AboutMenu;
